<template>
  <div v-if="this.$ekmtcCommon.isNotEmpty(detailList)" class="location_detail_box">
    <div class="location_detail_header">
      <div class="">
        <div class="ship_num">{{ detailParams.cntrNo }}</div>
        <!-- 메시지 나오는 부분 : 문장 행(msgVo) = rk 내림차순 목록에서 RK 99(데포 이동 등 단계 외 코드)가 아닌 첫 행 -->
        <div v-if="messageRk == 1" v-html="this.getMessage(msgVo)" class="ship_txt"></div>
        <div v-else-if="messageRk == 5" v-html="this.getMessage(msgVo)" class="ship_txt"></div>
        <div v-else-if="messageRk >= 7 && messageRk <= 9" v-html="this.getMessage(msgVo)" class="ship_txt"></div>
        <div v-else-if="messageRk >= 10 && messageRk <= 11">
          <div v-if="msgVo.ctrCd === 'IN' && msgVo.plcCd == msgVo.podPortCd && msgVo.podPortCd != msgVo.dlyPlcCd && messageRk == 10" class="ship_txt">
            {{ $t('msg.CART010G010.058') }}<!-- FULL CNTR 터미널에서 반출 -->
          </div>
          <div v-else-if="msgVo.plcCd == msgVo.podPortCd && msgVo.podPortCd != msgVo.dlyPlcCd && messageRk == 10" v-html="this.getMessage(msgVo)" class="ship_txt"></div>
          <!-- 에서 Outside depot로 이송되었습니다. -->
          <div v-else v-html="this.getMessage(msgVo)"></div>
        </div>
        <div v-else>
          <div v-if="msgVo.ctrCd === 'IN' && msgVo.plcCd == msgVo.podPortCd && msgVo.podPortCd != msgVo.dlyPlcCd && messageRk == 3">
            {{ $t('msg.CART010G010.059') }}<!-- FULL CNTR 터미널에서 반입 -->
          </div>
          <div v-else v-html="this.getMessage(msgVo)"></div>
        </div>
      </div>
      <!-- 내륙 시간 정보 -->
      <div>
        <div v-if="this.$ekmtcCommon.isNotEmpty(averageParams) && this.$ekmtcCommon.isNotEmpty(detailInlandList)" class="ship_time">
          <strong>{{ averageParams.podPortNm }}({{ averageParams.podPortCd }}) - {{ averageParams.dlyPlcNm }}</strong>
          <p>{{ $t('msg.CART010G010.057') }} <span>{{ averageParams.avgTnsDrtm }}</span></p>
        </div>
      </div>
    </div>

    <!-- 화물추적 현황 -->
    <ul class="location_detail">
      <!-- Empty Container Pick Up -->
      <li
        :style="detailParams.cntrTypCd !== 'TK' ? 'display: block;' : 'display: none;'"
        :class="[(rank < 3 ? 'active' : '')]"
      >
        <div class="ico ico_pickup">pickup</div>
        <div class="txt">
          Pick Up
        </div>
        <div class="ts_scroll">
          <div>
            <p>Empty<br> Gate Out</p>
            <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step01.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step01.mvntTm, ':') }}</span></p>
          </div>
        </div>
      </li>

      <!-- Port Of Loading -->
      <li :class="[rank >= 3 ? '' : (step02 !== undefined && Object.keys(step02).length > 0 ? 'active' : 'inactive')]">
        <div class="ico ico_loading">loading</div>
        <!-- 수출 반입풀(GTIOBF)이 선적항이 아닌 수취지(ICD 등)에서 찍힌 건은 Place of Receipt 로 표기 -->
        <div class="txt">
          <template v-if="isPorGateIn">Place of <br>Receipt</template>
          <template v-else>Port of <br>Loading</template>
        </div>
        <div class="ts_scroll">
          <div>
            <p>{{ fullEmptyLabel }} <br> Gate In </p>
            <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step02.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step02.mvntTm, ':') }}</span></p>
          </div>
        </div>
      </li>

      <!-- On Board -->
      <li :class="[rank > 4 ? '' : (step03 !== undefined && Object.keys(step03).length > 0 ? 'active' : 'inactive')]">
        <div class="ico ico_board">board</div>
        <div class="txt">
          On Board
        </div>
        <div class="ts_scroll">
          <div>
            <p>Loading</p>
            <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step03.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step03.mvntTm, ':') }}</span></p>
          </div>
        </div>
      </li>

      <!-- T/S -->
      <!-- <li :style="tsList.length > 0 && detailParams.cntrTypCd !== 'TK' ? 'display: block;' : 'display: none;'" :class="[tsList.length > 0 ? '' : (step03 !== undefined && Object.keys(step03) > 0 ? 'active' : 'inactive')]"> -->
      <li :style="tsList.length > 0 && detailParams.cntrTypCd !== 'TK' ? 'display: block;' : 'display: none;'" :class="[tsList.length > 0 ? (rank === 6 ? 'active' : '') : 'inactive']">
        <div class="ico ico_transhipped">transhipped</div>
        <div class="txt">
          (Transhipped)
        </div>
        <div class="ts_scroll">
          <div :v-if="tsList.length > 0 && tsInfo.cntrMvntCd === 'TS'" :key="tsInfo.rkCode">
            <p> T/S {{ tsInfo.tsIdx + 1 }}  <br /> {{ cntrStsNm }} </p>
            <p class="date">{{ this.$ekmtcCommon.changeDatePattern(tsInfo.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(tsInfo.mvntTm, ':') }}</span></p>
          </div>
          <button :class="[tsInfo.tsIdx === 0 ? 'btns prev disabled' : 'btns prev']" @click.prevent="preInfo(tsInfo.tsIdx, 'TS')">이전</button>
          <button :class="[tsInfo.tsIdx === tsInfo.tsCnt - 1 ? 'btns next disabled' : 'btns next']" @click.prevent="nextInfo(tsInfo.tsIdx, 'TS')">다음</button>
        </div>
      </li>

      <!-- Port Of Discharging -->
      <!-- <li :class="[rank > 7 && detailParams.cntrTypCd === 'TK' ? 'active' : rank > 7 || detailInlandList.length > 0 ? '' : tsList.length > 0 ? 'ts_scroll active' : 'inactive']"> -->
      <!-- <li :class="[rank > 7 && detailParams.cntrTypCd === 'TK' ? 'active' : rank > 7 || (detailInlandList.length > 0 && (dlyCtrCd === 'IN' || dlyCtrCd === 'ID')) ? '' : 'inactive']">-->
      <li :class="[rank > 7 || (detailInlandList.length > 0 && (dlyCtrCd === 'IN' || dlyCtrCd === 'ID')) ? '' : 'inactive']">
        <div class="ico ico_discharging">discharging</div>
        <div class="txt">
          Port of<br> Discharging
        </div>
        <div class="ts_scroll">
          <div>
            <p>Discharging </p>
            <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step04.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step04.mvntTm, ':') }}</span></p>
          </div>
        </div>
      </li>

      <!-- 인도 내륙 건일때 (ICD, CFS 이동)-->
      <template v-if="(dlyCtrCd === 'IN' && (inland.length > 0 || inlandListIn.length > 0)) || detailParams.icdRail === 'Y' || detailParams.icdTruckage === 'Y' || cyCfsYn === 'Y'">
        <!-- train or truck-->
        <li :style="(detailParams.cntrTypCd !== 'TK' && cyCfsYn === 'N') && (detailParams.icdRail === 'Y' || detailParams.icdTruckage === 'Y' )? 'display: block;' : 'display: none;'" :class="[rank > 9 ? '' : step05 !== undefined && Object.keys(step05).length > 0 ? 'ts_scroll active' : 'inactive']">
          <div class="ico ico_train">train_off</div>
          <div v-if="isInlandRail" class="txt">
            Train
          </div>
          <div v-else class="txt">
            Truck
          </div>
          <div class="ts_scroll">
            <div>
              <p v-if="isInlandRail">Transport by Rail</p>
              <p v-else>Transport by Truck</p>
              <!-- <p class="date">{{ inlandEtdDay }} <br> {{ inlandEtdTime }}</p> -->
              <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step05.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step05.mvntTm, ':') }}</span></p>
            </div>
          </div>
        </li>

        <!-- ICD : 반입 기록이 있거나, 반입 전이라도 B/L 구간 일정상 내륙(Rail/Truckage) 건이면 표시. 반입 전에는 회색(rank 무관 - 레일 출발 후 운송 중에도 미도착) -->
        <li :style="detailParams.cntrTypCd !== 'TK' && cyCfsYn === 'N' && (hasIcdArrival || detailParams.icdRail === 'Y' || detailParams.icdTruckage === 'Y') ? 'display: block;' : 'display: none;'" :class="[!hasIcdArrival ? 'inactive' : rank > 9 ? '' : 'ts_scroll active']">
          <div class="ico ico_icd">ICD</div>
          <div class="txt">
<!--            Inland Contatiner Depot-->
            Place of <br> Delivery
          </div>
          <div class="ts_scroll">
            <div>
              <p>Arrival</p>
              <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step05_1.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step05_1.mvntTm, ':') }}</span></p>
            </div>
          </div>
        </li>

        <!-- Gate Out -->
        <li :style="detailParams.cntrTypCd === 'TK' ? 'display: none;' : 'display: block;'" :class="[rank > 10 ? '' : step07 !== undefined && Object.keys(step07).length > 0 ? 'ts_scroll active' : 'inactive']">
          <div class="ico ico_pickup">Pick Up</div>
          <div class="txt">
            Pick Up
          </div>
          <div class="ts_scroll">
            <div>
              <p>{{ fullEmptyLabel }} <br>Gate Out </p>
              <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step07.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step07.mvntTm, ':') }}</span></p>
            </div>
          </div>
        </li>

        <!-- Return -->
        <li :style="detailParams.cntrTypCd !== 'TK' ? 'display: block;' : 'display: none;'" :class="[rank > 12 ? 'active' : step08 !== undefined && Object.keys(step08).length > 0 ? 'active' : 'inactive']">
          <div class="ico ico_return">Return</div>
          <div class="txt">
            <div>Return</div>
          </div>
          <div class="ts_scroll">
            <div>
              <p>Empty <br>Gate In</p>
              <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step08.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step08.mvntTm, ':') }}</span></p>
            </div>
          </div>
        </li>
      </template>

      <template v-else>
        <!-- Gate Out -->
        <li :style="(detailInlandList.length > 0 && dlyCtrCd === 'ID') ? 'display: none;' : 'display: block;'" :class="[rank > 9 ? '' : step05 !== undefined && Object.keys(step05).length > 0 ? 'ts_scroll active' : 'inactive']">
          <div class="ico ico_pickup">Gate Out</div>
          <div class="txt">
            Gate<br> Out
          </div>
          <div class="ts_scroll">
            <div>
              <p>{{ fullEmptyLabel }} <br>Gate Out </p>
              <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step05.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step05.mvntTm, ':') }}</span></p>
            </div>
          </div>
        </li>

        <!-- InLand -->
        <li :style="(detailInlandList.length > 0 && dlyCtrCd === 'ID')&& detailParams.cntrTypCd !== 'TK' ? 'display: block;' : 'display: none;'" :class="rank > 10 ? '' : [inland.length > 0 ? 'ts_scroll active' : 'inactive']">
          <div class="ico ico_train">train_off</div>
          <div class="txt">
            Train
          </div>
          <div class="ts_scroll">
            <div v-if="inlandFlag === 'D'">
              <p>Inland ETD</p>
              <p class="date">{{ inlandEtdDay }} <br> {{ inlandEtdTime }}</p>
            </div>
            <div v-if="inlandFlag === 'A'">
              <p>Inland ETA</p>
              <p class="date">{{ inlandEtaDay }} <br> {{ inlandEtaTime }}</p>
            </div>
            <button :class="[inlandFlag === 'D' ? 'btns prev disabled' : 'btns prev']" @click.prevent="chgInlandFlag('D')">이전</button>
            <button :class="[inlandFlag === 'A' ? 'btns next disabled' : 'btns next']" @click.prevent="chgInlandFlag('A')">다음</button>
          </div>
        </li>

        <!-- Return -->
        <li :style="detailParams.cntrTypCd !== 'TK' ? 'display: block;' : 'display: none;'" :class="[rank > 10 ? 'active' : 'inactive']">
          <div class="ico ico_return">Return</div>
          <div class="txt">
            <div>Return</div>
          </div>
          <div class="ts_scroll">
            <div>
              <p>Empty <br>Gate In</p>
              <p class="date">{{ this.$ekmtcCommon.changeDatePattern(step06.mvntDt, '-') }} <span>{{ this.$ekmtcCommon.changeTimePattern(step06.mvntTm, ':') }}</span></p>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div><!-- location_detail_box // -->
</template>

<script>
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import { rootComputed } from '@/store/helpers'

// 컨테이너 이동 단계(rk) 상수 - BE searchContainerStatusPrcDetailTrace 의 DECODE 값과 일치
const RK = {
  PICKUP: 1, // Empty Container Pick up (GTOOBE)
  LOADING: 3, // Port of Loading (GTIOBF)
  ONBOARD: 5, // On Board (LDGOBF)
  DISCHARGE: 8, // Port of Discharging (DISIBF)
  ICD: 9, // 도착지 반입 (GTIIBF) - ICD·CFS 공통 (이름만 ICD, 의미는 도착지 데포/CFS 반입)
  GATEOUT: 10, // Gate Out / 레일 출발 (GTOIBF)
  RETURN: 11, // 공컨 반납 (GTIIBE)
  ICD_GATEOUT: 12, // 도착지 반출 (반입 이후 GTOIBF, BE에서 재부여) - ICD·CFS 공통
  ICD_RETURN: 13 // 도착지 반납 (반입 이후 GTIIBE, BE에서 재부여) - rk 내림차순 첫 행이 반출(12)보다 앞에 오도록
}

export default {
  name: 'CargoLocationDetail',
  components: {
    EBreadcrumbs,
    EDateRangePicker: () => import('@/components/common/EDateRangePickerForOog'),
    EDatePicker: () => import('@/components/common/EDatePicker'),
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  props: {
    detailDateList: {
      type: Array,
      default: null
    },
    detailList: {
      type: Array,
      default: null
    },
    detailInlandList: {
      type: Array,
      default: null
    },
    inlandListIn: {
      type: Array,
      default: null
    },
    detailParams: {
      type: Object,
      default: null
    },
    averageParams: {
      type: Object,
      default: null
    },
    rank: {
      type: Number,
      default: null
    },
    dateFlag: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: ''
    },
    dlyCtrCd: {
      type: String,
      default: ''
    },
    cyCfsYn: {
      type: String,
      default: ''
    },
    // 화물 구분 VEP(CGO_MODE_CD 06, 공컨 화물) 여부 - CargoTracking.isVepCgo. true 면 Gate In/Out 설명을 Full 대신 Empty 로 표시
    isVepCgo: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      customComponent: null,
      cntrArr: {},
      cntrCnt: 0,
      messageRk: 0,
      //컨테이너 detail 관련 정보
      trackingDateList: [],
      trackingList: [],
      //로그인 없이 비엘 임시로 조회 시 imsi 제한 BL체크
      imsiblChk: '',
      //step처리 -- 추후 containerDetail를 component로 빼면 바꾼다.
      step01: {}, // Empty Container Pick up
      step02: {}, // Port of Loading
      step03: {}, // On Board
      step04: {}, // Port of Discharging
      step05: {}, // Gate Out
      step05_1: {}, // 도착지 반입 (ICD·CFS 공통)
      step06: {}, // Return
      step07: {}, // Gate Out(India)
      step08: {}, // Return(India)
      tsList: [], // TS 정보
      reTsList: [], // TS 정보
      tsInfo: {}, // TS 정보
      inland: [], // 내륙 운동
      inlandFlag: 'D', // 내륙 정보 플래그
      inlandEtaDay: '', // 내륙 정보
      inlandEtaTime: '', // 내륙 정보
      inlandEtdDay: '', // 내륙 정보
      inlandEtdTime: '', // 내륙 정보

      //검색한 containerList
      cntrList: [],
      selectCntrList: [],

      //초기에 보여줄 containerList
      container1: [],
      prdYn: process.env.VUE_APP_MODE !== 'PRD'
    }
  },
  computed: {
    ...rootComputed,
    // 상단 Current Location 문장에 쓸 행. detailList 는 rk 내림차순이라 첫 행이 가장 진행된 단계인데,
    // 반납 뒤 공컨 데포 이동(GTOIDE/GTIIDE 등 DECODE 밖 코드)은 RK 99 로 맨 위에 와서 getMessage 분기가 없어 문장이 비어 보였다.
    // → 99 가 아닌 첫 행(마지막 단계 행)을 쓴다. 전부 99 거나 비어 있으면 기존대로 첫 행. 정렬·단계 매핑·rank 는 그대로.
    // ICD 건 보정 : 흐름은 10(항만 반출) → 9(ICD 반입)인데 정렬은 10 이 위라, ICD 도착 후에도 10 문구가 나왔다.
    //              그 10 행보다 늦은 9 행이 있으면 가장 늦은 9 행으로 문장을 만든다(ICD 미사용 흐름은 10 뒤에 9 가 오지 않음).
    msgVo: function () {
      const list = this.detailList || []
      const found = list.find(item => item.rk !== 99) || list[0] || {}

      if (found.rk === 10 && this.isIcdInland) {
        const dt10 = (found.mvntDt || '') + (found.mvntTm || '')
        const later9 = list.filter(item => item.rk === 9 && (item.mvntDt || '') + (item.mvntTm || '') > dt10)

        if (later9.length > 0) {
          return later9.reduce((a, b) => (a.mvntDt + a.mvntTm >= b.mvntDt + b.mvntTm ? a : b))
        }
      }

      return found
    },
    // 내륙 운송 칸(Train/Truck) 라벨 : 실제 반출 행(step05 = RK 10)의 운송수단이 Rail/Truckage 면 그 값을 쓰고,
    // 반출 전(step05 없음)이거나 leg 매칭이 안 돼 기본값 'Truck' 인 경우엔 B/L 구간 일정(마지막 구간명 → icdRail)으로 판단.
    // (예: PNC4928611 On Board 단계 - 구간 2 Rail NSA→TKD 가 이미 등록돼 있어 반출 전에도 Train 표시)
    isInlandRail: function () {
      const tnsKndCd = this.step05 ? this.step05.tnsKndCd : ''

      if (tnsKndCd === 'Rail') {
        return true
      }
      if (tnsKndCd === 'Truckage') {
        return false
      }

      return this.detailParams.icdRail === 'Y'
    },
    // Port of Loading 반입 / Gate Out 반출 설명의 Full·Empty 구분 : VEP(공컨 화물)면 Empty, 그 외 Full
    fullEmptyLabel: function () {
      return this.isVepCgo ? 'Empty' : 'Full'
    },
    // 도착지(ICD) 반입 기록(step05_1 = RK 9 GTIIBF) 존재 여부
    hasIcdArrival: function () {
      return this.step05_1 !== undefined && this.step05_1 !== null && Object.keys(this.step05_1).length > 0
    },
    // ICD 내륙 운송 건 : B/L 양하항(POD) ≠ 인도지(DLY) 이고 B/L 마지막 구간이 Rail/Truckage
    // (양하항 ≠ 인도지만 보면 피더로 다른 항구에 인도되는 건까지 걸리므로 구간 운송수단을 함께 본다)
    isIcdInland: function () {
      const p = this.detailParams || {}

      if (this.$ekmtcCommon.isEmpty(p.blPodPortCd) || this.$ekmtcCommon.isEmpty(p.blDlyPlcCd)) {
        return false
      }

      return p.blPodPortCd !== p.blDlyPlcCd && (p.icdRail === 'Y' || p.icdTruckage === 'Y')
    },
    // 수출 반입풀 단계 라벨 : POR≠POL 이고 단계에 올라간 GTIOBF 행의 장소가 POL 이 아니면 "Place of Receipt", 그 외 "Port of Loading"
    // (예: DLH1022882 - 수취지 ICD DADRI(DRI) 반입 후 선적항 MUNDRA(MUN) 반입. 단계는 가장 이른 반입인 DRI 행)
    isPorGateIn: function () {
      const p = this.detailParams || {}
      const s = this.step02

      if (this.$ekmtcCommon.isEmpty(s) || this.$ekmtcCommon.isEmpty(s.plcCd)) {
        return false
      }
      if (this.$ekmtcCommon.isEmpty(p.porPlcCd) || this.$ekmtcCommon.isEmpty(p.polPortCd)) {
        return false
      }

      return p.porPlcCd !== p.polPortCd && s.plcCd !== p.polPortCd
    },
    cntrStsNm: function () {
      let nm = ''
      const cd = this.tsInfo.cntrStsCd

      if (this.$ekmtcCommon.isNotEmpty(cd)) {
        if (cd === 'DIS') {
          nm = 'Discharging'
        } else if (cd === 'LDG') {
          nm = 'Loading'
        } else if (cd === 'GTI') {
          nm = 'Gate In'
        } else if (cd === 'GTO') {
          nm = 'Gate Out'
        }
      }
      return nm
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const detailList = this.detailList
      const detailDateList = this.detailDateList

      if (this.$ekmtcCommon.isNotEmpty(detailList) && this.$ekmtcCommon.isNotEmpty(detailDateList)) {
        this.getCargoTrackingDetail()
      }
    },
    async getCargoTrackingDetail () {
        let trackingList = this.detailList
        let trackingDateList = this.detailDateList
        let inland = this.detailInlandList
        let step01MvntDtTm = '00000000000000'
        let step01MvntDt = '00000000'
        let step01MvntTm = '000000'
        let mvntDtTm

        // 초기화
        this.tsList = []
        this.reTsList = []

        //메세지에 사용할 가장 최근 단계 정보(RK 99 제외) 가져오기
        this.messageRk = this.msgVo.rk

        // 처음에 보여줄 내륙정보 셋팅 (마지막 LEG ETD/ETA 기준)
        if (this.$ekmtcCommon.isNotEmpty(this.detailParams)) {
          if (this.$ekmtcCommon.isNotEmpty(this.detailParams.inlandEtd)) {
            if (this.detailParams.inlandEtd.indexOf('/') > 0) {
              // 'YYYY.MM.DD/HH:MM' → 'YYYY-MM-DD' / 'HH:MM'. replace('.', '-') 는 첫 점만 바꿔 'YYYY-MM.DD' 가 되므로 전역 치환
              this.inlandEtdDay = this.detailParams.inlandEtd.replace(/\./g, '-').split('/')[0]
              this.inlandEtdTime = this.detailParams.inlandEtd.replace(/\./g, '-').split('/')[1]
              this.inlandEtaDay = this.detailParams.inlandEta.replace(/\./g, '-').split('/')[0]
              this.inlandEtaTime = this.detailParams.inlandEta.replace(/\./g, '-').split('/')[1]
            }
          }
        }

        // 무브먼트 데이터 중 1.Empty Container Pick up 이전 데어티 제외(SR.1398294)
        for (let item of trackingList) {
          if (item.rk === 1) {
            step01MvntDt = item.mvntDt || '00000000'
            step01MvntTm = item.mvntTm || '000000'

            step01MvntDtTm = item.mvntDt + item.mvntTm || '00000000000000'
          }
        }

        // detail정보 셋팅
        if (trackingList.length > 0) {
          // tsYn 무관 단일 루프 - TS행은 단계가 아닌 T/S 목록으로 분리하므로 가드 통합
          const isTs = this.detailParams.tsYn === 'Y'

          for (const item of trackingList) {
            mvntDtTm = item.mvntDt + item.mvntTm
            if (step01MvntDtTm > mvntDtTm) continue // Empty Container Pick up 이전 데이터 제외(SR.1398294)

            // 환적(TS) 이동은 단계가 아닌 T/S 목록으로 (tsYn='Y'인 건에서만 수집 - 기존 동작 보존)
            if (item.cntrMvntCd === 'TS') {
              if (isTs) this.tsList.push(item)
              continue
            }

            // 메인 단계 매핑 (rk → step)
            if (item.rk === RK.PICKUP) {
              this.step01 = item // Empty Container Pick up
            } else if (item.rk === RK.LOADING) {
              this.step02 = item // Port of Loading
            } else if (item.rk === RK.ONBOARD) {
              this.step03 = item // On Board
            } else if (item.rk === RK.DISCHARGE) {
              this.step04 = item // Port of Discharging
            } else if (item.rk === RK.GATEOUT) {
              this.step05 = item // Gate Out / 레일 출발
            } else if (item.rk === RK.ICD) {
              this.step05_1 = item // 도착지 반입 (ICD·CFS 공통)
            } else if ((item.rk === RK.RETURN || item.rk === RK.ICD_RETURN || (item.rk === RK.LOADING && item.rkNext === undefined)) && !this.$ekmtcCommon.isEmpty(this.step06)) {
              // Return : 가장 늦은 값 유지
              if (this.$ekmtcCommon.isEmpty(this.step06.mvntDt) || this.step06.mvntDt < item.mvntDt) {
                this.step06 = item
              }
            }

            // 내륙 도착지건(ICD·CFS 공통, Rail/Truck) : Gate Out(반출)=rk12 / Return(반납)=rk13(반입 이후) 또는 rk11 - 국가무관, 반납과 무관하게 즉시 표시
            if (item.tnsKndCd === 'Rail' || item.tnsKndCd === 'Truck') {
              if (item.rk === RK.ICD_GATEOUT) {
                this.step07 = item
              }
              if (item.rk === RK.RETURN || item.rk === RK.ICD_RETURN) {
                this.step08 = item
              }
            }
          }

          // T/S 목록 정리 (TS 없는 건은 빈 배열이라 no-op)
          this.tsList.sort((a, b) => {
            return b.mvntDt - a.mvntDt || b.mvntTm - a.mvntTm
          })

          if (this.tsList.length > 0) {
            this.tsList = this.tsList.filter(item => {
              if (item.blNo !== undefined) {
                return item
              }
            })

            this.reTsList = this.tsList.reverse()
            for (let k = 0; k < this.reTsList.length; k++) {
              this.reTsList[k].tsCnt = this.reTsList.length
              this.reTsList[k].tsIdx = k
            }
            // 처음에 TS화면에 보여줄 정보 설정
            if (this.rank > 6) {
              this.tsInfo = this.reTsList[this.reTsList.length - 1]
            } else {
              this.tsInfo = this.reTsList[0]
            }
          }
        }

        const cargoSteps = {
          step01: this.step01, // Empty Container Pick up
          step02: this.step02, // Port of Loading
          step03: this.step03, // On Board
          step04: this.step04, // Port of Discharging
          step05: this.step05, // Gate Out
          step06: this.step06, // Return
          step07: this.step07, // Gate Out(India)
          step08: this.step08 // Return(India)

        }

        this.$store.commit('trans/updateCargoSteps', cargoSteps)
        this.$store.commit('trans/updateTsList', this.tsList)
        this.$store.commit('trans/updateCargoDetailList', this.detailList)

        // if (this.rank >= 6 && this.reTsList.length > 2) {
        //   this.$store.commit('trans/updateTsInfo', this.reTsList[this.reTsList.length - 1])
        // } else {
          this.$store.commit('trans/updateTsInfo', this.tsInfo)
        // }

        this.trackingList = trackingList
        this.trackingDateList = trackingDateList
        this.inland = inland
    },
    //ts정보 스크롤 처리
    preInfo (idx, flag) {
      if (flag === 'TS') {
        this.tsInfo = this.reTsList[idx - 1]
      } else if (flag === 'IN') {
        this.inInfo = this.reInList[idx + 1]
      }
    },
    nextInfo (idx, flag) {
      if (flag === 'TS') {
        this.tsInfo = this.reTsList[idx + 1]
      } else if (flag === 'IN') {
        this.inInfo = this.reInList[idx + 1]
      }
    },
    //inland 플래그 처리
    chgInlandFlag (flag) {
      if (this.$ekmtcCommon.isNotEmpty(flag)) {
        this.inlandFlag = flag
      }
    },
    //메시지 처리
    getMessage (svo) {
      const flag = this.dateFlag
      let msg = ''
      let dvo = this.detailDateList[0] || {} // B/L 미연결 컨테이너는 날짜 목록(dtVo)이 비어 있음
      let svoIn = ''
      // svo.rk = 12
      // svo.shprVanYn = 'N'

      if (svo.rk >= 12 && this.dlyCtrCd === 'IN') {
        svoIn = this.detailList[2]
      }

      if (svo.rk === 1) {
        msg = this.$t('msg.CART010G010.001', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, prevctrCd: svo.plcNm, prevplcCd: svo.dlyCyNm, cgoClsDt: this.$ekmtcCommon.changeDatePattern(dvo.cgoClsDt), demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt), detDt: this.$ekmtcCommon.changeDatePattern(dvo.detDt), rkNext: svo.rkNext })
      } else if (svo.rk === 3 && svo.blNo !== undefined) {
        msg = this.$t('msg.CART010G010.002', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, etd: this.$ekmtcCommon.changeDatePattern(dvo.etd) })
      } else if (svo.rk === 5) {
        if (svo.rkNext === 6) {
          msg = this.$t('msg.CART010G010.004', { prevctrCd: svo.podPortNm, prevplcCd: svo.podTrmlNm })
          } else {
          msg = this.$t('msg.CART010G010.003', { eta: this.$ekmtcCommon.changeDatePattern(svo.eta), prevctrCd: svo.podPortNm, prevplcCd: svo.podTrmlNm })
        }
      } else if (svo.rk === 6) {
        msg = this.$t('msg.CART010G010.005', { plcNm: svo.plcNm, trmlNm: svo.trmlNm })
      } else if (svo.rk === 7) {
        msg = this.$t('msg.CART010G010.006', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, eta: this.$ekmtcCommon.changeDatePattern(dvo.eta), prevctrCd: svo.podPortNm, prevplcCd: svo.podTrmlNm })
      } else if (svo.rk === 8) {
        // 2022-04-08 화물추적에서 POD가 KR일시 OFC일자를 적용
        if (svo.shprVanYn === 'Y') {
          if (svo.ctrCd === 'KR') {
            msg = this.$t('msg.CART010G010.007_1', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.ofcDt, '-') })
          } else {
            // 2022-04-08 화물추적에서 DEM/ DET/ DET(COMBINED)/ OFC 여부에 따라 일자적용 (01 => DET(COMBINED), 02 => OFC, 03 => DEM/DET)
            if (flag === '01') {
              msg = this.$t('msg.CART010G010.007_1', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.detcbDt, '-') })
            } else if (flag === '02') {
              msg = this.$t('msg.CART010G010.007_1', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.ofcDt, '-') })
            } else {
              msg = this.$t('msg.CART010G010.007_1', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt, '-') })
            }
          }
        } else {
          if (svo.ctrCd === 'KR') {
            msg = this.$t('msg.CART010G010.007', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.ofcDt, '-') })
          } else if (svo.ctrCd === 'US') {
            // 2022-04-08 화물추적에서 DEM/ DET/ DET(COMBINED)/ OFC 여부에 따라 일자적용 (01 => DET(COMBINED), 02 => OFC, 03 => DEM/DET)
            if (flag === '01') {
              msg = this.$t('msg.CART010G010.007_2', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.detcbDt, '-') })
            } else if (flag === '02') {
              msg = this.$t('msg.CART010G010.007_2', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.ofcDt, '-') })
            } else {
              msg = this.$t('msg.CART010G010.007_2', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt, '-') })
            }
          } else {
            // 2022-04-08 화물추적에서 DEM/ DET/ DET(COMBINED)/ OFC 여부에 따라 일자적용 (01 => DET(COMBINED), 02 => OFC, 03 => DEM/DET)
            if (flag === '01') {
              msg = this.$t('msg.CART010G010.007', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.detcbDt, '-') })
            } else if (flag === '02') {
              msg = this.$t('msg.CART010G010.007', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.ofcDt, '-') })
            } else {
              msg = this.$t('msg.CART010G010.007', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt, '-') })
            }
          }
        }
      } else if (svo.rk === 9) {
        if (svo.shprVanYn === 'Y') {
          msg = this.$t('msg.CART010G010.007_1', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt, '-') })
        } else {
          if (svo.ctrCd === 'US') {
            msg = this.$t('msg.CART010G010.007_2', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt, '-') })
          } else {
            msg = this.$t('msg.CART010G010.007', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, demDt: this.$ekmtcCommon.changeDatePattern(dvo.demDt, '-') })
          }
        }
      } else if (svo.rk === 10) {
        if (this.isIcdInland) {
          // ICD 내륙 운송 건의 항만 반출(레일/트럭 출발) : shprVanYn·국가 무관 공통 문구 (반납 예정지·마감일 없음)
          msg = this.$t('msg.CART010G010.009_3', { plcNm: svo.plcNm, trmlNm: svo.trmlNm })
        } else if (svo.shprVanYn === 'Y') {
          msg = this.$t('msg.CART010G010.009_2', { plcNm: svo.plcNm, trmlNm: svo.trmlNm })
        } else if (svo.ctrCd === 'KR') {
          msg = this.$t('msg.CART010G010.009', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, detDt: this.$ekmtcCommon.changeDatePattern(dvo.ofcDt, '-'), prevctrCd: svo.podPortNm, prevplcCd: svo.rtnCyNm })
        } else {
          msg = this.$t('msg.CART010G010.009', { plcNm: svo.plcNm, trmlNm: svo.trmlNm, detDt: this.$ekmtcCommon.changeDatePattern(dvo.detDt, '-'), prevctrCd: svo.podPortNm, prevplcCd: svo.rtnCyNm })
        }
      } else if (svo.rk === 11 || svo.rk === 13) {
        // 13 = 도착지 반출(12) 이후 반납(BE 재부여). 문구는 일반 반납(11)과 동일하게 '반납되었습니다' 를 쓴다
        if (svo.plcCd === 'INC' || svo.plcCd === 'BGK' || svo.plcCd === 'USN') {
          const prevPlcCd = svo.plcNm.split(',')[0]
          msg = this.$t('msg.CART010G010.010', { prevplcCd: this.$ekmtcCommon.isNotEmpty(prevPlcCd) ? prevPlcCd : '', trmlNm: this.$ekmtcCommon.isNotEmpty(svo.rtnCyNm) ? svo.rtnCyNm : svo.trmlNm })
        } else {
          msg = this.$t('msg.CART010G010.010', { prevplcCd: this.$ekmtcCommon.isNotEmpty(svo.podPortNm) ? svo.podPortNm : '', trmlNm: this.$ekmtcCommon.isNotEmpty(svo.rtnCyNm) ? svo.rtnCyNm : svo.trmlNm })
        }
      } else if (svo.rk === 12) {
        msg = this.$t('msg.CART010G010.009', { plcNm: svoIn.plcNm, trmlNm: svo.trmlNm, detDt: this.$ekmtcCommon.changeDatePattern(dvo.detDt, '-'), prevctrCd: svoIn.podPortNm, prevplcCd: this.$ekmtcCommon.isNotEmpty(svoIn.rtnCyNm) ? svoIn.rtnCyNm : svo.trmlNm })
      }

      return msg
    }
  }
}
</script>

 <style scoped>
 </style>
